module.exports = __webpack_public_path__ + "static/media/37.f3c02729.png";